const SET_UNREAD_ANNOUNCEMENTS = (state, payload) => {
  state.unreadAnnouncements = payload;
}

export {
  SET_UNREAD_ANNOUNCEMENTS,
}